import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEO from '@/components/base/SEO';
import CategoryHeader from './components/CategoryHeader';
import ComicGrid from './components/ComicGrid';
import EditorPicks from './components/EditorPicks';
import { categoryInfo } from '@/mocks/category';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const info = slug ? categoryInfo[slug] : null;

  if (!slug || !info) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <p className="text-foreground-500">分类不存在</p>
      </div>
    );
  }

  return (
    <>
      <SEO
        title={`${info.name}韩国漫画-无删减下拉式-51漫画网`}
        description={`51漫画网${info.name}分类提供${info.count}+部无删减韩国漫画，下拉式流畅阅读，高清画质，更新及时，${info.description.substring(0, 80)}`}
        keywords={`${info.name}韩国漫画,${info.name}韩漫,无删减漫画,下拉式漫画,51漫画网`}
        canonical={`https://51manhua.com/category/${slug}`}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <div className="pt-16">
            <Breadcrumb items={[
              { label: '首页', path: '/' },
              { label: '分类大全', path: '/category/lian-ai' },
              { label: info.name },
            ]} />
          </div>
          <CategoryHeader slug={slug} />
          <ComicGrid slug={slug} />
          <EditorPicks slug={slug} />
        </main>
        <Footer />
      </div>
    </>
  );
}